import { useLazyQuery } from '@apollo/client';
import { useLocale } from '../';
import { LOOKUP_OPTIONS } from '../graphql';
export const useLookupOptions = ({ extraData } = {}) => {
    const { t } = useLocale();
    const [fetch, { data, loading, error }] = useLazyQuery(LOOKUP_OPTIONS, {});
    const options = (data?.lookupOptions || []);
    const fetchOptions = async ({ clientId, entityType, fieldCode, query, fetchAll = false, ids = [], pagination = {
        page: 1,
        pageSize: 2000,
    }, orderBy, orderByDir, }) => {
        const result = await fetch({
            variables: {
                spec: {
                    clientId,
                    entityType: entityType.toUpperCase(), // the enum is not uppercase in types, but should be when passing to graphql
                    fieldCode,
                    value: query,
                    fetchAll,
                    ids,
                    ...(extraData || {}),
                    ...(pagination ? { pagination } : {}),
                    ...(orderBy ? { orderBy } : {}),
                    ...(orderByDir ? { orderByDir } : {}),
                },
            },
        });
        const items = result.data?.lookupOptions?.items || [];
        const page = result.data?.lookupOptions?.page || 1;
        const pageSize = result.data?.lookupOptions?.pageSize || 2000;
        const total = result.data?.lookupOptions?.total || 0;
        const options = (items || []).map(opt => ({
            ...opt,
            label: opt.localize ? t(opt.label) : opt.label,
        }));
        return { options, items, page, pageSize, total };
    };
    return {
        options,
        loading,
        error,
        fetchOptions,
    };
};
